class RugCardSwatches extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('.rug-card-swatches__item');
    if (!button) return;
    event.preventDefault();

    this.querySelectorAll('.rug-card-swatches__item').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');

    const cardWrap = this.closest('.rug-card-wrap');
    if (!cardWrap) return;

    const variantUrl = button.dataset.variantUrl;
    const variantImage = button.dataset.variantImage;

    if (variantImage) {
      const image = cardWrap.querySelector('.card__media img');
      if (image) {
        image.src = variantImage;
        image.removeAttribute('srcset');
      }
    }

    if (variantUrl) {
      cardWrap.querySelectorAll('.card__heading a, .full-unstyled-link').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
    }
  }
}

if (!customElements.get('rug-card-swatches')) customElements.define('rug-card-swatches', RugCardSwatches);
